import React from "react";
import { useTranslation } from "react-i18next";

import DPCard from "../../../../../../packages/DPCard";
import WPHeading from "../../../../../../packages/WPHeading";

import { LicenseIcon } from "../../../../../../assets/icons";

import "./UserLicenseCard.scss";

const UserDefaultLicenseCard = ({ description }) => {
  const { t } = useTranslation();
  return (
    <div className="user-default-license-card">
      <DPCard className="user-default-license-card-outer">
        <LicenseIcon />
        <WPHeading
          text={t(description)}
          type="default"
          size="small"
          secondary
        />
      </DPCard>
    </div>
  );
};

export default UserDefaultLicenseCard;
